<template lang="pug">
    d2-container
        el-form(:inline='true', :model='dataForm'  size='mini' label-width="60px" label-position='left' :modal-append-to-body='false'  label-suffix=':' )
            el-row(:span='24')
              el-col(:md='6' :sm="12")
                el-form-item(label="姓名" )
                    el-input.inputWidth(v-model='dataForm.name' clearable )
              el-col(:md='6' :sm="12")
                el-form-item(label="手机" )
                    el-input.inputWidth(v-model='dataForm.phone' clearable )
        el-row(style="padding-bottom:15px;" :span="24")
            el-col(:md='23' :sm="5")
                el-button(type='primary'  v-if="isAuth('px:coach:add')" @click="releaseReserveOpr('add')" ) 发布预约
            el-col( :md='1' :sm="14" style='float:right;')
                el-button(@click='queryList()',type='primary',icon='el-icon-search',style='float:right;') 查 询
        el-table(:data="tableData" style="width: 100%" v-loading='dataListLoading' border @selection-change='selectionChangeHandle')
            el-table-column(type='selection' header-align='center' align='center'  width='50')
            el-table-column(prop='name',header-align='center',align='center',label='姓名')
            el-table-column(prop='phone',header-align='center',align='center',label='手机号' width="150")
            el-table-column(prop='courseName',header-align='center',align='center',label='预约课程名称')
            el-table-column(prop='time',header-align='center',align='center',label='预约时间范围')
            el-table-column(prop='count',header-align='center',align='center',label='班级人数' width="100")
            el-table-column(prop='memberLevel',header-align='center',align='center',label='级别限制' width="100")
            el-table-column(prop='hourFee',header-align='center',align='center',label='课时费/元/人' width="100")
            //- el-table-column(prop='stateName',header-align='center',align='center',label='状态')
            el-table-column(prop='stateName',header-align='center',align='center',label='状态' width="100")
                template(slot-scope="scope")
                    font(v-if='scope.row.stateName == "未审核"')
                      span.danger()
                      span() &nbsp; 未审核
                    font(v-if='scope.row.stateName == "已拒绝"')
                      span.warning()
                      span() &nbsp; 已拒绝
                    font(v-if='scope.row.stateName == "进行中"')
                      span.success()
                      span() &nbsp; 进行中

                    font(v-if='scope.row.stateName == "已结束"')
                      span.warning()
                      span() &nbsp; 已结束
                    //- font(v-if='scope.row.state === 6' )
                    //-   span.warning()
                    //-   span() &nbsp; 已开训
                    //- font(v-if='scope.row.state === 7')
                    //-   span.warning()
                    //-   span() &nbsp; 已结束
                    //- font(v-if='scope.row.state === 8')
                    //-   span.warning()
                    //-   span() &nbsp; 已取消
            //- el-table-column(prop='remark',header-align='center',align='center',label='备注' )
            el-table-column(header-align='center',align='center',label='操作' width='100')
                    template(slot-scope="scope")
                      el-menu.menuPonit(   @open="handleOpen" @close="handleClose" :collapse="isCollapse" )
                        el-submenu(index="1")
                            template(slot="title")
                                i(class="el-icon-more" style='color:#02B90D;')
                            el-menu-item-group()
                                el-menu-item(index="1-1" @click='showView(scope.row.id)' type="text" v-if="isAuth('px:coach:detail')" ) 查看详情
                                el-menu-item(index="1-2" type="text" @click="releaseReserveOpr('update',scope.row.id)"  v-if="isAuth('px:coach:update')&&scope.row.state==0" ) 修改
                                el-menu-item(index="1-3" type="text" @click="reviewRelease(scope)" v-if="isAuth('px:coach:update')&&scope.row.state==0" ) 审核发布
                                el-menu-item(index="1-4" @click="userManageOpr(scope.row.id)"  type="text"  v-if="isAuth('px:coach:update')&&scope.row.state==1||scope.row.state==3" ) 预约人员管理
                                el-menu-item(index="1-5" type="text"  @click="releaseReserveOpr('copyNew',scope.row.id)" v-if="isAuth('px:coach:update')" ) 复制并新建
        el-pagination(@size-change='sizeChangeHandle', @current-change='currentChangeHandle', :current-page='pageIndex', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize', :total='totalPage', layout='total, sizes, prev, pager, next, jumper')
        // 发布预约
        ReleaseReserve(v-if="releaseVisible", ref="releaseReserve" @refreshgetDataList='getDataList')
        // 预约人员管理
        ReserveuserManager(v-if="userManageVisible", ref="userManage")
        //- 查看详情
        queryView(v-if='queryViewVisible', ref="queryView", @refreshDataList='getDataList')
</template>

<script>
// import table from './table.js'
// import AddOrUpdate from './add-or-update'
import queryView from './query-view'
import ReleaseReserve from './release-reserve'
import ReserveuserManager from './reserve-user-manager'
// import QueryView from './query-view'
export default {
  name: 'single',
  data () {
    return {
      table: {
        // columns: table.columns,
        data: null,
        size: 'mini',
        stripe: true,
        border: true
      },
      linkFormVisible: false,
      isCollapse: true,
      loading: null,
      addOrUpdateVisible: false,
      queryViewVisible: false,
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      totalPage: 0,
      dataListLoading: false,
      dataForm: {
        vacateName: '',
        vacateId: '',
        trainName: '',
        trainId: '',
        trainType: '',
        orgName: '' //主办方
      },
      addLinkFrom: {
        name: '',
        idCard: '',
        account: '',
        linkPerson: ''
      },
      coach: {}, //当前选择的教练
      LinkFromRule: {
        account: [
          { required: true, message: '必须填写关联账户!', trigger: 'blur' }
        ],
        linkPerson: [
          { required: true, message: '必须填写会员!', trigger: 'blur' }
        ]
      },
      dataListSelections: [],
      sysOrgList: [],
      releaseVisible: false, // 发布预约
      userManageVisible: false // 预约人员管理
    }
  },
  components: {
    // AddOrUpdate,
    queryView,
    ReleaseReserve, // 发布预约
    ReserveuserManager // 预约人员管理
  },
  mounted () {
    this.getDataList()
    this.initCity()
  },
  methods: {
    // 审核发布
    reviewRelease (row) {
      this.showView(row.row.id, 'release')
      // this.$confirm('是否审核发布?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning'
      // })
      //   .then(() => {
      //     this.showView(row.row.id, 'release')
      //   })
      //   .catch(() => {
      //     this.$message.info('已取消')
      //   })
    },
    // 发布预约
    releaseReserveOpr (type, id) {
      this.releaseVisible = true
      this.$nextTick(() => {
        this.$refs.releaseReserve.init(type, id)
      })
    },
    // 预约人员管理
    userManageOpr (id) {
      this.userManageVisible = true
      this.$nextTick(() => {
        this.$refs.userManage.init(id)
      })
    },
    //操作三点
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    queryList () {
      this.pageIndex = 1
      this.getDataList()
    },
    showView (id, flagType) {
      this.queryViewVisible = true
      this.$nextTick(() => {
        this.$refs.queryView.init(id, flagType)
      })
    },
    getDataList () {
      this.dataListLoading = true

      this.$http({
        url: this.$http.adornUrl('/pxSubscribe/list'),
        method: 'get',
        params: this.$http.adornParams({
          page: this.pageIndex,
          rows: this.pageSize,
          name: this.dataForm.name || null,
          phone: this.dataForm.phone || null,
          limit: this.pageSize
        })
        // data: {
        //   page: this.pageIndex,
        //   rows: this.pageSize,
        //   name: this.dataForm.name || null,
        //   phone: this.dataForm.phone || null,
        //   limit: this.pageSize
        // }
      }).then((data) => {
        if (data && data.code === 0) {
          this.tableData = data.data.rows
          this.totalPage = data.data.total
        } else {
          this.tableData = []
          this.totalPage = 0
        }
        this.dataListLoading = false
      })
    },
    // 每页数
    sizeChangeHandle (val) {
      this.pageSize = val
      this.pageIndex = 1
      this.getDataList()
    },
    // 当前页
    currentChangeHandle (val) {
      this.pageIndex = val
      this.getDataList()
    },
    initCity () {
      this.$http({
        url: this.$http.adornUrl('/sysOrg/list'),
        method: 'get'
      }).then((data) => {
        this.sysOrgList = data && data.code === 0 ? data.list : []
      })
    }
  }
}
</script>
<style >
/* 操作三点 菜单样式 */
@import '../../../css/opr3dot.css';
.inputWidth {
  width: 200px;
}
.inputWidth_g {
  width: 75%;
}
.el-form--inline .el-form-item {
  display: inline-block;
  margin-right: 0px;
  vertical-align: top;
}

/* 提示框 */
.el-tooltip__popper.is-light {
  border: 1px solid #c0c4cc;
}

.el-tooltip__popper[x-placement^='bottom'] .popper__arrow {
  border-bottom-color: grey !important ;
}

.toolTip > p {
  margin: 0;
  padding-top: 10px;
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  color: #606266;
}

.el-dialog {
  position: relative;
  margin: 0 auto 80px;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
}
</style>
